var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 3.84896-2.766 2.86187c-.2944.30462-.6999.47663-1.1235.47663h-3.92298v3.92294c0 .4237-.17201.8292-.47663 1.1236l-2.86187 2.766 2.86188 2.766c.30461.2944.47662.6998.47662 1.1235v3.923h3.92298c.4236 0 .8291.172 1.1235.4766l2.766 2.8619 2.766-2.8619c.2944-.3046.6999-.4766 1.1235-.4766h3.923v-3.923c0-.4237.172-.8291.4766-1.1235l2.8619-2.766-2.8619-2.766c-.3046-.2944-.4766-.6999-.4766-1.1235v-3.92304h-3.923c-.4236 0-.8291-.17201-1.1235-.47663zm-1.1235-1.53554c.6142-.6355 1.6328-.6355 2.247 0l2.8986 2.99904h4.1029c.863 0 1.5625.69955 1.5625 1.5625v4.10294l2.9991 2.8985c.6355.6143.6355 1.6329 0 2.2471l-2.9991 2.8985v4.103c0 .8629-.6995 1.5625-1.5625 1.5625h-4.1029l-2.8986 2.999c-.6142.6355-1.6328.6355-2.247 0l-2.8986-2.999h-4.10288c-.86294 0-1.5625-.6996-1.5625-1.5625v-4.103l-2.99904-2.8985c-.6355-.6142-.6355-1.6328 0-2.2471l2.99904-2.8985v-4.10294c0-.86295.69956-1.5625 1.5625-1.5625h4.10288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.06252 15c0-3.2792 2.65828-5.93754 5.93748-5.93754s5.9375 2.65834 5.9375 5.93754-2.6583 5.9375-5.9375 5.9375-5.93748-2.6583-5.93748-5.9375zm5.93748-4.0625c-2.2436 0-4.0625 1.8188-4.0625 4.0625 0 2.2436 1.8189 4.0625 4.0625 4.0625 2.2437 0 4.0625-1.8189 4.0625-4.0625 0-2.2437-1.8188-4.0625-4.0625-4.0625z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon_settings.a759ab624bea7bb037989728c3132daf.svg";
export { ForwardRef as ReactComponent };